this.M = this.M || {};

this.M.TableList = function(el, options) {
    var self = this;
    self.el = el;
    self.dataSource = options.dataSource;
    self.template = options.template;
    self.linkClick = options.linkClick;
    self.buttonClick = options.buttonClick;
    self.extraData = options.extraData;
    self.onRefresh = options.onRefresh;
    self.postProcess = options.postProcess;
    self.suspendRefresh = options.suspendRefresh;
	self.loadingElement = $(M.templates.loading());
	self.data = null;
	self.refreshing = false;
	self.refreshPending = false;
	self.refreshPendingCB = null;
};

this.M.TableList.prototype = {
    refresh: function(cb) {
        var self = this;
        if(self.suspendRefresh) return;
		
		if(self.refreshing) {
			self.refreshPending = true;
			self.refreshPendingCB = cb;
			return;
		}
		
		self.refreshing = true;
        
        self.beginLoading();
		
        self.dataSource(function(data) {
			self.refreshing = false;
            self.data = data;
			self.endLoading();
            self.render();
			
			if(cb) {
				cb();
			}
			
			if(self.refreshPending) {
				cb = self.refreshPendingCB;
				self.refreshPending = false;
				self.refreshPendingCB = null;
				
				self.refresh(cb);
			}
        });
    },
    beginLoading: function() {
        this.el.prepend(
            this.loadingElement
        );
		console.log("B: Scrolling start at " + window.scrollY);
		var offset = 32;//this.loadingElement.height();
		//if(window.scrollY > offset) { 
			window.scrollBy(0, offset);
			console.log("B: Scrolling offset to " + window.scrollY);
		//}
    },
    endLoading: function() {
		var offset = 32;//this.loadingElement.height();
		console.log("E: Scrolling start at " + window.scrollY);
        this.loadingElement.detach();
		if(window.scrollY >= offset) {
			//window.scrollBy(0, -offset);
			console.log("E: Scrolling offset to " + window.scrollY);
		}
    },
    render: function() {
        var self = this;

        
        $("*", self.el).off("click");
        
        var func = function(d, f) {
            return function(e) { 
                f.call(this, e, d); //"this" is the button itself, not self
            };
        };
        
        this.el.empty();
        for(var i = 0; i < self.data.length; i++) {
            var data = {};
            var k;
            if(self.extraData) {
                for(k in self.extraData) {
                    data[k] = self.extraData[k];
                }
            }
            
            for(k in self.data[i]) {
                data[k] = self.data[i][k];
            }
            
            if(self.postProcess) {
                data = self.postProcess(data);
            }
            
            var t = $.parseHTML(self.template(data));
            //t.data("data", self.data[i]);
            
            if(self.linkClick) {
                $("a", t).on("click", func(data, self.linkClick));
            }
            if(self.buttonClick) {
                $("button", t).on("click", func(data, self.buttonClick));
            }
            
            this.el.append(t);
        }

        if(this.onRefresh)  {
            this.onRefresh();
        }
    }
};